import React, { useState } from 'react';
import { ChatConversation } from '../../components/ChatConversation';
import { MessageSquareTextIcon, CheckCircleIcon } from 'lucide-react';
export function PhaseDiscussion({
  phase,
  team,
  onComplete
}) {
  const [discussionPoints, setDiscussionPoints] = useState([]);
  const [isCompleting, setIsCompleting] = useState(false);
  const discussionPrompts = {
    1: 'Discuss your skills, experiences, and what you hope to contribute to the startup. What are your strengths and weaknesses?',
    4: "Discuss potential solutions to the problem you've identified. What unique approach can your team take? How will your solution stand out?"
  };
  const handleConversationSave = conversation => {
    // Extract key points from the conversation
    // This is simplified - in a real app, you would use more sophisticated NLP
    const lastMessage = conversation[conversation.length - 1];
    if (lastMessage && lastMessage.role === 'assistant') {
      // Extract key points when AI responds
      const content = lastMessage.content;
      const points = content.split('.').filter(sentence => sentence.trim().length > 20).slice(0, 3).map(point => point.trim());
      if (points.length > 0) {
        setDiscussionPoints(prev => {
          const newPoints = [...prev];
          points.forEach(point => {
            if (!newPoints.includes(point)) {
              newPoints.push(point);
            }
          });
          return newPoints.slice(0, 5); // Keep only top 5 points
        });
      }
    }
  };
  const completePhase = () => {
    setIsCompleting(true);
    // Generate a summary of the discussion
    const summary = `
      ## ${phase.name} Summary
      The team discussed the following key points:
      ${discussionPoints.map(point => `- ${point}`).join('\n')}
This discussion has helped the team ${phase.id === 1 ? 'understand each other' : 'strengths, and how they can work together effectively'};    'align on a solution approach that leverages their unique perspectives.';
}
`;
    onComplete(summary);
  };
  return <div data-id="element-229">
      <div className="mb-4" data-id="element-230">
        <p className="text-gray-700" data-id="element-231">
          {discussionPrompts[phase.id] || 'Discuss with your team members to progress in this phase.'}
        </p>
      </div>
      <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-232">
        <h3 className="text-lg font-medium flex items-center mb-3" data-id="element-233">
          <MessageSquareTextIcon className="w-5 h-5 mr-2 text-indigo-600" data-id="element-234" />
          Team Discussion
        </h3>
        <div className="h-96 mb-4 border border-gray-200 rounded-lg overflow-hidden" data-id="element-235">
          <ChatConversation systemPrompt={`;
You;
are;
a;
helpful;
facilitator;
for (the; '${phase.name}'; phase)
    of;
Bridges;
of;
Life.
Help;
the;
team;
have;
a;
productive;
discussion;
about;
$;
{
    phase.id === 1 ? 'their skills and what they bring to the team' :
        'potential solutions to their identified problem';
}
Ask;
thoughtful;
questions, summarize;
key;
points, and;
help;
the;
team;
reach;
consensus.
The team consists of: ${team.map(m => m.name).join(', ')};
`} onConversationSave={handleConversationSave} data-id={`;
phase - $;
{
    phase.id;
}
-discussion `} />
        </div>
        <div className="mb-4" data-id="element-236">
          <h4 className="text-md font-medium mb-2" data-id="element-237">Key Points Captured:</h4>
          {discussionPoints.length > 0 ? <ul className="space-y-2" data-id="element-238">
              {discussionPoints.map((point, index) => <li key={index} className="flex items-start" data-id="element-239">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-240" />
                  <span className="text-sm text-gray-700" data-id="element-241">{point}</span>
                </li>)}
            </ul> : <p className="text-sm text-gray-500 italic" data-id="element-242">
              No key points captured yet. Continue your discussion.
            </p>}
        </div>
      </div>
      <div className="flex justify-end" data-id="element-243">
        <button className={`;
px - 4;
py - 2;
rounded - md;
$;
{
    discussionPoints.length >= 3 && !isCompleting
        ? 'bg-indigo-600 text-white hover:bg-indigo-700'
        : 'bg-gray-200 text-gray-500 cursor-not-allowed';
}
`} disabled={discussionPoints.length < 3 || isCompleting} onClick={completePhase} data-id="element-244">
          Complete Discussion
        </button>
      </div>
    </div>;
}